export default () => ({
  id: null,
  date_from: null,
  date_to: null,
  keywords: null,
  talent: [],
  sort: 'latest_post_at',
  order: 'desc',
  regions: []
})
